export default __webpack_public_path__ + "8a65a78a2e4cb9befedccd1a709d75b6.png";